/* Veem meetmotor (Sam 03-09: "elke klik, elke leave, elke tijd, elke foto").
   Verzamelt gedragsevents en publiceert ze via Shopify.analytics.publish;
   de custom pixel "loods-analytics" (consent-gated) stuurt ze door naar GA4.
   AVG: geen PII in payloads - alleen paden, labels, indexen, tijden.
   Eventnamen: veem_page, veem_click, veem_card, veem_foto, veem_variant,
   veem_scroll, veem_tijd (hartslag per 30 s actief, sinds 30-09), veem_leave,
   veem_drawer, veem_zoek. */
(function () {
  if (!window.Shopify || !Shopify.analytics || !Shopify.analytics.publish) return;
  // eigen testverkeer niet meten (Sam 03-10): headless/renderproxy, zie veem-cookies.liquid
  if (navigator.webdriver === true || /HeadlessChrome|veem-render/i.test(navigator.userAgent || "")) return;

  var PAD = location.pathname;
  var HANDLE = (PAD.match(/\/products\/([^\/?#]+)/) || [])[1] || "";

  function pub(naam, data) {
    try {
      data = data || {};
      data.pad = PAD;
      if (HANDLE) data.handle = HANDLE;
      Shopify.analytics.publish("veem_" + naam, data);
    } catch (e) {}
  }

  /* --- paginacontext ------------------------------------------------------ */
  pub("page", {
    ref: (document.referrer || "").slice(0, 120),
    breed: window.innerWidth,
    tpl: PAD === "/" ? "home" : PAD.split("/")[1] || "overig"
  });

  /* --- elke klik (gedelegeerd, passief) ----------------------------------- */
  document.addEventListener("click", function (e) {
    var el = e.target.closest("a,button,summary,[role=button]");
    if (!el) return;
    var kaart = e.target.closest(".product-card");
    var d = {
      tekst: (el.getAttribute("aria-label") || el.textContent || "").trim().slice(0, 60),
      href: (el.getAttribute("href") || "").slice(0, 120),
      sectie: ((e.target.closest(".shopify-section") || {}).id || "").split("__").pop().slice(0, 40)
    };
    if (kaart) {
      var t = kaart.querySelector('[class*="product_title"] p, .product-title');
      d.kaart = t ? t.textContent.trim().slice(0, 40) : "";
      var lijst = kaart.closest(".shopify-section");
      d.lijst = lijst ? lijst.id.split("__").pop().slice(0, 30) : "";
      pub("card", d);
      return;
    }
    pub("click", d);
  }, { capture: true, passive: true });

  /* --- fotoweergaven: welke foto (index) is in beeld ---------------------- */
  var fotoGezien = {};
  function fotoObserver() {
    var slides = document.querySelectorAll("media-gallery slideshow-slide, media-gallery .media-gallery__grid > li");
    if (!slides.length || fotoObserver.klaar) return;
    fotoObserver.klaar = true;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        var alle = [].slice.call(document.querySelectorAll("media-gallery slideshow-slide, media-gallery .media-gallery__grid > li"));
        var i = alle.indexOf(en.target) + 1;
        if (i > 0 && !fotoGezien[i]) {
          fotoGezien[i] = 1;
          pub("foto", { index: i });
        }
      });
    }, { threshold: 0.6 });
    slides.forEach(function (s) { io.observe(s); });
  }

  /* --- variantwissel (kleur/maat) ----------------------------------------- */
  document.addEventListener("change", function (e) {
    if (e.target.matches && e.target.matches("variant-picker input, .variant-picker input, fieldset.variant-option--buttons input")) {
      pub("variant", { waarde: String(e.target.value).slice(0, 40) });
    }
  }, true);

  /* --- scroll-diepte ------------------------------------------------------ */
  var diepten = [25, 50, 75, 100], gezien = {};
  window.addEventListener("scroll", function () {
    var h = document.documentElement;
    var p = Math.round((h.scrollTop + window.innerHeight) / h.scrollHeight * 100);
    for (var i = 0; i < diepten.length; i++) {
      var m = diepten[i];
      if (p >= m && !gezien[m]) { gezien[m] = 1; pub("scroll", { diepte: m }); }
    }
  }, { passive: true });

  /* --- tijd op pagina: hartslag + vertrek ---------------------------------
     30-09 (Sam: "hoe lang, overal"): GA4 krijgt via de Shopify-pixel geen
     engagement-tijd, dus meten we het zelf. Elke 30 s ACTIEVE tijd (tabblad
     zichtbaar) een veem_tijd met de opgetelde seconden, tot 20 minuten. Elke
     veem_tijd staat dus voor 30 s kijken: aantal x 30 / paginaweergaven =
     gemiddelde actieve tijd per pagina. Vertrek gaat op 'hidden' (mobiel:
     tabblad wisselen) en op pagehide, een keer per verberging. */
  var start = Date.now(), actief = 0, laatste = Date.now();
  var STAP = 30, MAX = 1200, volgende = STAP;
  setInterval(function () {
    if (document.visibilityState === "visible") {
      actief += (Date.now() - laatste) / 1000;
      while (actief >= volgende && volgende <= MAX) {
        pub("tijd", { sec: volgende });
        volgende += STAP;
      }
    }
    laatste = Date.now();
  }, 5000);
  var vertrokken = false;
  function vertrek() {
    if (vertrokken) return;
    vertrokken = true;
    if (document.visibilityState === "visible") actief += (Date.now() - laatste) / 1000;
    pub("leave", { sec: Math.round(actief), totaal: Math.round((Date.now() - start) / 1000) });
  }
  document.addEventListener("visibilitychange", function () {
    if (document.visibilityState === "hidden") vertrek();
    else { vertrokken = false; laatste = Date.now(); }
  });
  window.addEventListener("pagehide", vertrek);

  /* --- cart-drawer open + zoeken ------------------------------------------ */
  new MutationObserver(function (muts) {
    muts.forEach(function (m) {
      var el = m.target;
      if (el.matches && el.matches(".cart-drawer, cart-drawer, dialog") && (el.hasAttribute("open") || el.open)) {
        if (el.className && String(el.className).indexOf("cart") >= 0) pub("drawer", {});
      }
    });
    fotoObserver();
  }).observe(document.documentElement, { attributes: true, attributeFilter: ["open"], subtree: true, childList: true });

  document.addEventListener("submit", function (e) {
    var f = e.target;
    if (f.matches && (f.matches('form[action*="/search"]') || f.querySelector('input[name="q"]'))) {
      var q = (f.querySelector('input[name="q"]') || {}).value || "";
      pub("zoek", { q: String(q).slice(0, 60) });
    }
  }, true);

  fotoObserver();
})();
